import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as gkApi from '../api/gkApi';

const GK_USERS_KEY = ['gk-users'];

export const useGKUsers = () => {
  return useQuery({
    queryKey: GK_USERS_KEY,
    queryFn: () => gkApi.listGKUsers(),
    staleTime: 30_000,
  });
};

export const useCreateGKUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: gkApi.CreateGKUserRequest) => gkApi.createGKUser(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GK_USERS_KEY });
    },
  });
};

export const useDeleteGKUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (username: string) => gkApi.deleteGKUser(username),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GK_USERS_KEY });
    },
  });
};

export const useApproveGkUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (username: string) => gkApi.approveGkUser(username),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GK_USERS_KEY });
    },
  });
};

export const useRejectGkUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (username: string) => gkApi.rejectGkUser(username),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GK_USERS_KEY });
    },
  });
};
